import { isNil } from 'lodash';
import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBButton } from '@shared/components/button';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext, grid } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import classNames from './AnchoredSheetTitleBar.module.css';

interface Props {
  title?: string;
  leftIcon?: MBIconV2Name;
  leftIconColor?: string;
  leftIconSize?: number;
  leftIconAnchorName?: string;
  leftTitlePosition?: number;
  onLeftIconPress?: (node: React.Component) => void;
  rightIcon?: MBIconV2Name;
  rightIconColor?: string;
  rightIconSize?: number;
  rightButtonText?: string;
  rightTitlePosition?: number;
  titleSize?: number;
  onRightIconPress?: (node: React.Component) => void;
  showBorder?: boolean;
  height?: number;
}

const DEFAULT_ICON_SIZE = 5;

export function AnchoredSheetTitleBar({
  title,
  leftIcon,
  leftIconColor,
  leftIconSize,
  leftIconAnchorName,
  onLeftIconPress,
  rightIcon,
  rightIconColor,
  rightIconSize,
  rightButtonText,
  titleSize,
  onRightIconPress,
  showBorder = true,
  height,
}: Props) {
  const colorTheme = useContext(ColorThemeContext);
  const isDesktop = useIsDesktop();
  const defaultTitleSize = isDesktop ? 16 : 20;

  return (
    <View className={[classNames.titleBar, showBorder && classNames.bordered]} style={{ height }}>
      <div className={classNames.left}>
        {leftIcon && onLeftIconPress && (
          <View
            paddingHorizontal={1.5}
            style={leftIconAnchorName ? { anchorName: leftIconAnchorName } : undefined}
          >
            <MBTouchableOpacity onPress={onLeftIconPress}>
              <MBIconV2
                name={leftIcon}
                size={leftIconSize ?? grid(DEFAULT_ICON_SIZE)}
                color={leftIconColor || colorTheme.foregroundActive}
              />
            </MBTouchableOpacity>
          </View>
        )}
      </div>

      <div className={classNames.title} style={{ fontSize: titleSize ?? defaultTitleSize }}>
        {title}
      </div>

      <div className={classNames.right}>
        {rightIcon && onRightIconPress && (
          <View paddingHorizontal={2}>
            <MBTouchableOpacity onPress={onRightIconPress}>
              <MBIconV2
                name={rightIcon}
                size={rightIconSize ?? grid(DEFAULT_ICON_SIZE)}
                color={rightIconColor || colorTheme.foregroundActive}
              />
            </MBTouchableOpacity>
          </View>
        )}
        {!isNil(onRightIconPress) && !isNil(rightButtonText) && !rightIcon && (
          <View paddingHorizontal={2}>
            <MBButton
              size="small"
              theme="normal"
              onPress={onRightIconPress}
              title={rightButtonText}
            />
          </View>
        )}
      </div>
    </View>
  );
}
